module.exports = __webpack_public_path__ + "static/media/unknown.ef70bd3b.png";